<form (ngSubmit)="parse()"> 
  <mat-form-field appearance="fill" [style.width.px]=300>
    <mat-label>References</mat-label>
    <textarea type="text" matInput [formControl]="references" required></textarea>
  </mat-form-field>
  <button mat-raised-button type="submit" color="accent">Parse</button>
  
</form>

<button mat-raised-button (click)="parseAllFailedEmails()">Parse all failed emails</button>

<button mat-raised-button (click)="calculatePictureStats()">calculate picture stats</button>

<button mat-raised-button (click)="createIndex()">create search index</button>

<button mat-raised-button (click)="triggerItemToSellCategoryCodesMigration()">trigger category codes migration</button>

<div>
  <form (ngSubmit)="createNewIndex()"> 
    <mat-form-field appearance="fill" [style.width.px]=300>
      <mat-label>New index name</mat-label>
      <input type="text" matInput [formControl]="newIndexName" required/>
    </mat-form-field>
    <button mat-raised-button type="submit" color="accent">Create new index</button>
  </form>
</div>

<div>
  <form (ngSubmit)="syncAllItemsToIndex()"> 
    <mat-form-field appearance="fill" [style.width.px]=300>
      <mat-label>Index name</mat-label>
      <input type="text" matInput [formControl]="syncAllItemsIndexName" required/>
    </mat-form-field>
    <button mat-raised-button type="submit" color="accent">Sync all items to index</button>
  </form>
</div>

<div>
  <form (ngSubmit)="deleteIndex()"> 
    <mat-form-field appearance="fill" [style.width.px]=300>
      <mat-label>Old index name</mat-label>
      <input type="text" matInput [formControl]="oldIndexName" required/>
    </mat-form-field>
    <button mat-raised-button type="submit" color="accent">Delete index</button>
  </form>
</div>

<div>
  <form (ngSubmit)="createThumbnail()"> 
    <mat-form-field appearance="fill" [style.width.px]=300>
      <mat-label>Original key</mat-label>
      <input type="text" matInput [formControl]="originalKey" required/>
    </mat-form-field>
    <button mat-raised-button type="submit" color="accent">Create thumbnail</button>
  </form>
</div>

<div>
  <form (ngSubmit)="deleteItem()"> 
    <mat-form-field appearance="fill" [style.width.px]=300>
      <mat-label>Item id</mat-label>
      <input type="text" matInput [formControl]="itemIdToDelete" required/>
    </mat-form-field>
    <button mat-raised-button type="submit" color="accent">Delete</button>
  </form>
</div>

<div>
  <form (ngSubmit)="deleteItemFromSearch()"> 
    <mat-form-field appearance="fill" [style.width.px]=300>
      <mat-label>Item id</mat-label>
      <input type="text" matInput [formControl]="itemIdToDeleteFromSearch" required/>
    </mat-form-field>
    <button mat-raised-button type="submit" color="accent">Delete from search</button>
  </form>
</div>